"use strict";
import { useState, useEffect } from "react";
async function parseQuoteError(response) {
  try {
    const errorData = await response.json();
    const message = errorData?.message?.toLowerCase() || "";
    if (message.includes("no swap path found")) {
      return "No swap path found";
    }
  } catch (parseError) {
    console.warn("Quote error response:", parseError);
  }
  return "Failed to fetch quote";
}
export function useEisenQuote(params) {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchQuote = async () => {
      if (!params) {
        setQuote(null);
        return;
      }
      setLoading(true);
      setError(null);
      try {
        const queryParts = [
          `fromAddress=${encodeURIComponent(params.fromAddress)}`,
          `fromChain=${params.fromChain}`,
          `toChain=${params.toChain}`,
          `fromToken=${encodeURIComponent(params.fromToken)}`,
          `toToken=${encodeURIComponent(params.toToken)}`,
          `fromAmount=${encodeURIComponent(params.fromAmount)}`,
          `toAddress=${encodeURIComponent(params.toAddress)}`
        ];
        if (params.order) {
          queryParts.push(`order=${params.order}`);
        }
        if (params.integrator) {
          queryParts.push(`integrator=${encodeURIComponent(params.integrator)}`);
        }
        if (params.fee !== void 0) {
          queryParts.push(`fee=${params.fee}`);
        }
        if (params.slippage) {
          queryParts.push(`slippage=${params.slippage}`);
        }
        if (params.referrer) {
          queryParts.push(`referrer=${encodeURIComponent(params.referrer)}`);
        }
        if (params.includedDex) {
          queryParts.push(`includedDex=${encodeURIComponent(params.includedDex)}`);
        }
        if (params.maxSplit) {
          queryParts.push(`maxSplit=${params.maxSplit}`);
        }
        if (params.maxEdge) {
          queryParts.push(`maxEdge=${params.maxEdge}`);
        }
        const queryString = queryParts.join("&");
        const response = await fetch(`https://hiker.hetz-01.eisenfinance.com/public/v1/quote?${queryString}`, {
          headers: {
            "X-EISEN-KEY": process.env.REACT_APP_EISEN_API_KEY || ""
          }
        });
        if (!response.ok) {
          const errorMessage = await parseQuoteError(response);
          throw new Error(errorMessage);
        }
        const data = await response.json();
        setQuote(data);
      } catch (err) {
        console.error("Error fetching quote from Eisen API:", err);
        setError(err instanceof Error ? err.message : "Failed to fetch quote");
        setQuote(null);
      } finally {
        setLoading(false);
      }
    };
    fetchQuote();
  }, [
    params?.fromAddress,
    params?.fromChain,
    params?.toChain,
    params?.fromToken,
    params?.toToken,
    params?.fromAmount,
    params?.toAddress,
    params?.order,
    params?.slippage,
    params?.fee,
    params?.integrator,
    params?.maxSplit,
    params?.maxEdge,
    params?.includedDex
  ]);
  return {
    quote,
    loading,
    error
  };
}
